import React, { useMemo } from "react";

import { Executor } from "../../../../../../../services";
import { useTypedSelector } from "../../../../../../../redux/store";
import { CellContentRoot } from "../../../../../../LightTable";
import { Row } from "..";

const TaxiServiceCellContent: React.FC<TaxiServiceCellContent.Props> = ({
	item,
}) => {
	const lang = useTypedSelector((state) => state.session.language);
	const content = useMemo(
		() => item.taxiService?.settlement?.[lang] ?? "",
		[item.taxiService?.settlement, lang],
	);

	return (
		<CellContentRoot
			alignItems="center"
			w="100%"
			h="100%"
			p="0"
			cursor="pointer"
		>
			<Row active={item.active}>{content}</Row>
		</CellContentRoot>
	);
};

declare namespace TaxiServiceCellContent {
	interface Props {
		item: Executor.Model;
	}
}

export default React.memo(TaxiServiceCellContent);
